/**
 * Os endereços de webhook que o RPG Desk aceita (docs/spec/web-plugins.md, "Internet"): só Zapier,
 * Make e IFTTT, por https. A tela Integrações confere antes de enviar; o servidor confere de novo.
 */
import { MESSAGES, type Lang } from './messages.js';

/** O que há de errado no endereço, ou null. */
export function webhookUrlProblem(raw: string, lang: Lang = 'pt'): string | null {
  const M = MESSAGES[lang].webhook;
  let url: URL;
  try {
    url = new URL(raw.trim());
  } catch {
    return M.invalid;
  }
  if (url.protocol !== 'https:') return M.https;
  if (url.port || url.username || url.password) return M.extras;
  const host = url.hostname.toLowerCase();
  if (host === 'hooks.zapier.com') return url.pathname.startsWith('/hooks/catch/') ? null : M.zapier;
  if (/^hook\.[a-z0-9-]+\.make\.com$/.test(host)) return url.pathname.length > 1 ? null : M.make;
  if (host === 'maker.ifttt.com') return /^\/trigger\/[^/]+(\/json)?\/with\/key\/[^/]+\/?$/.test(url.pathname) ? null : M.ifttt;
  return M.other;
}
